import styles from '~/components/Layout/layout.module.scss';
import LeftNavGroup from '~/components/Layout/LeftNav/LeftNavGroup.tsx';
import {
  getAppEnvironmentsNavConfig,
  getAppWorkspaceNavConfig,
  getEnvAppNavConfig,
  LeftNavType
} from '~/components/Layout/LeftNav/utils.tsx';
import { useAppData } from '~/components/AppData';
import { EnvironmentData } from '~/api';
import { mergeProps, Show } from 'solid-js';
import BackNavigation from '~/components/Layout/LeftNav/BackNavigation.tsx';
import { isEnvHospedContext } from '~/utils/commonUtils.ts';

type LeftNavProps = {
  type: LeftNavType;
};
export default function LeftNav(props: LeftNavProps) {
  const merged = mergeProps({}, props);
  const appData = useAppData();

  const getLeftNavConfig = () => {
    if (isEnvHospedContext()) {
      return getEnvAppNavConfig();
    }
    switch (merged.type) {
      case LeftNavType.ENVIRONMENT:
        return getAppEnvironmentsNavConfig(
          appData.selectedEnvironment as EnvironmentData
        );
      case LeftNavType.WORKSPACE:
        return getAppWorkspaceNavConfig();
    }
  };

  return (
    <div class={styles.leftNavContainer}>
      <Show when={merged.type === LeftNavType.WORKSPACE}>
        <div class={`pl-5`}>
          <BackNavigation />
        </div>
      </Show>
      <div class={`flex-grow overflow-y-auto`}>
        <LeftNavGroup groups={getLeftNavConfig()} />
      </div>
      {/* @todo see if logo is needed again */}
      {/*<div class={`px-2`}>*/}
      {/*  <img*/}
      {/*    alt={`Scalekit Logo`}*/}
      {/*    src={ScalekitLogo}*/}
      {/*  />*/}
      {/*</div>*/}
    </div>
  );
}
